import { decomposeColor, rgbToHex } from '@mui/material/styles';

// calculates the resulting color of having `color` with `opacity` over `basis`
export const transluce = (color: string, opacity: number, basis = '#ffffff') => {
  const colorValue = decomposeColor(color).values.slice(0, 3);
  const basisValue = decomposeColor(basis).values;
  const result = colorValue.map((v, i) =>
    Math.ceil(basisValue[i]! + (v - basisValue[i]!) * opacity),
  );
  return rgbToHex(`rgb(${result.join(',')})`);
};
